export default "__VITE_ASSET__C6JyTS7H__"